import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../services/auth.service';
import { ConsumerDispute, ConsumerDisputeIdentity, ConsumerDisputeNote } from './models/consumerDispute';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DisputeTrackerService {

  constructor(public http: HttpClient,
    public toast: ToastrService,
    private auth: AuthService) {
      
    }

  
  public saveConsumerDispute(dispo: ConsumerDispute) {
    return this.http.post(environment.baseURl + '/api/dispute', dispo);
  }

  public resolveConsumerDispute(dispo: ConsumerDispute) {
    return this.http.post(environment.baseURl + '/api/dispute/resolve', dispo);
  }

  public getAllConsumerDisputes() {
    return this.http.get(environment.baseURl + '/api/dispute');
  }

  public checkDisputedIdentity(cdi: ConsumerDisputeIdentity) {
    return this.http.post(environment.baseURl + '/api/dispute/exists', cdi);
  }

  public saveConsumerDisputeNote(note: ConsumerDisputeNote) {
    return this.http.post(environment.baseURl + '/api/dispute/note', note);
  }

  public getConsumerDisclosureNotes(disputeId: number) {
    return this.http.get<ConsumerDisputeNote[]>(environment.baseURl + '/api/dispute/note/' + disputeId);
  }

  public sendDisputeEmailApplicant(reportNumber: number) {
    return this.http.get(environment.baseURl + `/api/dispute/email/applicant/` + reportNumber);
  }

  public sendDisputeEmailProperty(reportNumber: number) {
    return this.http.get(environment.baseURl + `/api/dispute/email/property/` + reportNumber);
  }

  public getDisputeByScreeningId(screeningId: number) {
    return this.http.get<ConsumerDispute>(environment.baseURl + `/api/dispute/by-screening/` + screeningId);
  }

  public reactivateConsumerDispute(disputeId: number) {
    return this.http.post(environment.baseURl + `/api/dispute/reactivate/` + disputeId, {});
  }
  
}
